import { Dispatch, ThunkAction } from '../../../../types/actions';
import { root } from '../../../../store/constants';
import {
    SegmentBoardEvent,
    SegmentBoardSettingsSourceValue
} from '../../../../middlewares/segment/trackEntities/boardEvents';
import { segmentTrackAction } from '../../../../middlewares/segment';
import { IGetState } from '../../../../types/types';
import { EBoardSetting } from '../../aside_panel/boardDetails/details/TabDetails/components/TabDetails/types';
import { getUserShowSplitSettings } from '../../../../store/model/authUser/selectors/getUserShowSplitSettings';
import {
    BOARD_DETAILS_SELECTOR_MAP
} from '../../aside_panel/boardDetails/details/TabDetails/components/TabDetails/constants';

export const openBoardSettings = (
    tab: string,
    sourceValue: SegmentBoardSettingsSourceValue
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        if (!tab) tab = '';
        if (!root.App.controller.isRelatedPanelNotOpened()) return;
        if (tab) {
            if (getUserShowSplitSettings(getState())) {
                tab = '/' + tab.toLowerCase(); // к низкому реестру, чтобы не кидалось в глаза в url
            } else { // old settings нужно для скрола к секции
                tab = '/' + BOARD_DETAILS_SELECTOR_MAP[tab];
            }
        }
        root.App.router.navigate(root.App.router.getUrl('edit' + tab), {trigger: true});
        dispatch(segmentTrackAction(SegmentBoardEvent.BOARD_DETAILS, {
            name: 'source',
            value: sourceValue
        }));
    };
    return action;
}
